<script setup>
import {NuxtLink} from '#components'


import {layoutConfig} from '@layouts'
import {can} from '@layouts/plugins/casl'
import {getComputedNavLinkToProp, getDynamicI18nProps, isNavLinkActive} from '@layouts/utils'

const props = defineProps({
  item: {
    type: null,
    required: true,
  },
  isSubItem: {
    type: Boolean,
    required: false,
    default: false,
  },
})
</script>

<template>
  <li
    v-if="can(item.action, item.subject)"
    :class="[{
      'sub-item': props.isSubItem,
      'disabled': item.disable,
    }]"
    class="nav-link"
  >
    <component
      :is="item.to ? NuxtLink : 'a'"
      :class="{ 'router-link-active router-link-exact-active': isNavLinkActive(item, $router) }"
      v-bind="getComputedNavLinkToProp(item)"
    >
      <component
        :is="layoutConfig.app.i18n.enable ? 'i18n-t' : 'span'"
        class="nav-item-title"
        v-bind="getDynamicI18nProps(item.title, 'span')"
      >
        {{ item.title }}
      </component>
      <span
        v-if="item.badgeContent"
        :class="item.badgeClass || 'bg-error'"
        class="nav-item-badge"
      >
        {{ item.badgeContent }}
      </span>
    </component>
  </li>
</template>

<style lang="scss">
.layout-horizontal-nav {
  .nav-link a {
    display: flex;
    align-items: center;
    border-radius: 0 !important;
    line-height: 30px !important;
    text-transform: uppercase;
    position: relative;
    font-size: clamp(13px, calc(13px + (18 - 13) * ((100vw - 1378px) / (1920 - 1378))), 16px);
  }

  .nav-item-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    margin-left: 6px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1;
    color: #fff;
    border-radius: 10px;

    &.bg-error {
      background-color: rgb(var(--v-theme-error));
    }

    &.bg-warning {
      background-color: rgb(var(--v-theme-warning));
    }

    &.bg-success {
      background-color: rgb(var(--v-theme-success));
    }

    &.bg-primary {
      background-color: rgb(var(--v-theme-primary));
    }
  }
}
</style>
